import styled from 'styled-components';
import { Flex, FlexColumn, FlexGrow } from '../Flex';

export const InputGroup = styled(FlexColumn)` ${({ theme }) => `
  padding-left:${theme.padding[10]};
  padding-right:${theme.padding[10]};
`}`;

export const InputRow = styled(Flex)` ${({ theme }) => `
  gap:calc(${theme.padding[8]} * 4);
  padding-top:${theme.padding[4]};
  padding-bottom:${theme.padding[6]};
  width:100%;
  align-items: flex-start;
`}`;

export const EmptyInput = styled(FlexGrow)`
  width:50%;
`;

export const InputGroupBreak = styled.div` ${({ theme }) => `
  height:2px;
  background:${theme.colours.neutral[8]};
  margin-left:${theme.padding[8]};
  margin-right:${theme.padding[8]};
  margin-bottom:${theme.padding[2]};
`}`;
